(function ($) {
    $(() => {
        $('.js-contact-form').parsley({
            trigger: 'change',
            successClass: 'is-success',
            errorClass: 'is-error',
            classHandler(el) {
                return el.$element.closest('.input-wrapper-col');
            },
            errorsWrapper: '<div class="invalid-message"></div>',
            errorTemplate: '<span></span>'
        });

        var $select = $('#select-beast').selectize({
            sortField: 'text',
            onDropdownOpen: function () {
                $('.selectize-dropdown').addClass('bordered');
            },
            onDropdownClose: function () {
                $('.selectize-dropdown').removeClass('bordered');
            }
        });

        function namevalidation(inputtxt) {
            var regexp = /(^[a-zA-ZáéíóöőúüűÁÉÍÓÖŐÚÜŰ]+[ ][a-zA-Z áéíóöőúüűÁÉÍÓÖŐÚÜŰ]+)\w+/gm;
            if (inputtxt.match(regexp)) {
                return true;
            } else {
                return false;
            }
        }

        function resetContactForm() {
            $('.contact-form').trigger('reset');
            $('.contact-select').val('');

            /* 		var control = $select[0].selectize;
            control.clear(); */
            //grecaptcha.reset();
            $('.contact-form-wrapper, .kotelezo-row').hide();
            $('.success-section').show();
        }

        $('.error-btn').on('click', function (e) {
            e.preventDefault();
            $('.error-section').hide();
            $('.contact-form-wrapper, .kotelezo-row').show();
        });

        // front-form
        $('.contact-form').on('submit', function (e) {
            e.preventDefault();
            const $this = $(this);

            const contact_name_string = $('#contact-name').val();

            if (!namevalidation(contact_name_string)) {
                $('.contact-name-error-wrapper').show();
            } else if ($('.selectize-input').hasClass('not-full')) {
                $('.error-select-wrapper').addClass('show');
            } else if ($('.contact-check').prop('checked')) {
                $(this)
                    .find('.contact-btn')
                    .prop('disabled', true);
                const formdata = $this.serializeArray();
                //formdata[formdata.length] = {name: 'recaptcha', value: $(this).find('#g-recaptcha-response').val()};
                $.ajax({
                    url: ajax.ajaxurl,
                    type: 'POST',
                    data: {
                        action: 'contact_form',
                        datas: formdata
                    },
                    success(data) {
                        const result = JSON.parse(data);

                        if (result.status == 'success') {
                            resetContactForm();
                        } else {
                            $('.contact-form-wrapper').hide();
                            $('.kotelezo').addClass('hide');
                            $('.error-section').show();
                        }
                    }
                }).done(response => {
                    $this.find('.contact-btn').prop('disabled', false);
                });
            } else {
                $('.error-check-wrapper').addClass('show');
            }
        });

        $('.contact-check').change(() => {
            $('.error-check-wrapper').removeClass('show');
        });

        $('select').change(() => {
            $('.error-select-wrapper').removeClass('show');
        });

        $('#contact-name').keyup(function () {
            $('.contact-name-error-wrapper').hide();
        });
    });
})(jQuery);
